import { render, staticRenderFns } from "./CardEvent.vue?vue&type=template&id=6b97f678&"
import script from "./CardEvent.vue?vue&type=script&lang=js&"
export * from "./CardEvent.vue?vue&type=script&lang=js&"
import style0 from "./CardEvent.vue?vue&type=style&index=0&id=6b97f678&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports